export default {

}



// WEBPACK FOOTER //
// ./src/app/employee/dashboard/gadget/components/active-agenda/components/consultations-made/resources/index.js